import {GetValidateBank} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {RemoteGetValidateBank} from 'data/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {RefundFlowEndPoints} from '../../../endpoints';

export const makeGetValidateBank = (): GetValidateBank =>
	new RemoteGetValidateBank(
		makeBFFApiUrl(RefundFlowEndPoints.validateBank),
		makeAuthorizeHttpClientDecorator(),
	);
